/** Prefer inner editable content over whole `.ce-block` for offset walks. */
export function resolveSerializedWalkRoot(blockEl: HTMLElement): HTMLElement {
  return (
    blockEl.querySelector<HTMLElement>('.ce-block__content') ??
    blockEl.querySelector<HTMLElement>('[contenteditable="true"]') ??
    blockEl
  );
}
